export const TAG_REQUIRED_MESSAGE = 'Select a tag to continue';
const TAG_UNAVAILABLE_MESSAGE =
  'That tag is no longer available. Please pick another one.';
const DEFAULT_MESSAGE = 'Unable to update the alert. Please try again.';

const TAG_REQUIRED_CODES = new Set([
  'resolution_tag_required',
  'dismissal_tag_required',
]);
const TAG_UNAVAILABLE_CODES = new Set([
  'invalid_resolution_tag',
  'invalid_dismissal_tag',
]);

interface ApiErrorBody {
  message?: string;
  data?: { code?: string };
}

/**
 * The shipment API rejects with either the axios error (response nested under
 * `response`) or the response itself, and the backend puts its error code in
 * `data.data.code`. Read both shapes.
 */
const readBody = (error: unknown): ApiErrorBody | undefined => {
  const source = error as {
    response?: { data?: { data?: ApiErrorBody } };
    data?: { data?: ApiErrorBody };
  } | null;
  return source?.response?.data?.data ?? source?.data?.data;
};

/** User-facing text for a failed Mark as resolved or Dismiss request. */
export const getAlertCloseErrorMessage = (error: unknown): string => {
  const body = readBody(error);
  const code = body?.data?.code;
  if (code && TAG_REQUIRED_CODES.has(code)) return TAG_REQUIRED_MESSAGE;
  if (code && TAG_UNAVAILABLE_CODES.has(code)) return TAG_UNAVAILABLE_MESSAGE;
  return body?.message || DEFAULT_MESSAGE;
};
